import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { debounce } from "lodash";
import {
  Avatar,
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Input,
  Modal,
  Row,
  Select,
  Switch,
  Table,
  Tooltip,
  message,
  Upload,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  FileImageOutlined,
  SearchOutlined,
  UploadOutlined,
  ClearOutlined, PlusOutlined, PrinterOutlined, CloseCircleFilled
} from "@ant-design/icons";
import { SetRoute } from "../scripts/action";
import { CheckPermission, PriceFormat, SearchFormat } from "../scripts/helpers";
import { Constants, Permissions } from "../scripts/settings";
import API from "../scripts/api";
import Resources from "../scripts/resources";
import PaginationInfo from "../components/PaginationInfo";
import PrintBarcodeForm from "../forms/PrintBarcodeForm";
import DeleteBarcode from "../forms/DeleteBarcode";
import PrintView from "../views/Print";
import moment from "moment-jalaali";
import DatePicker from "react-modern-calendar-datepicker";


class PrintBarcode extends Component {
  constructor() {
    super();

    this.state = {
      data: [],
      filter: [],
      mainCats: [],
      identifiers: [],
      shelfs: [],
      rows: [],
      types:[],
      pagination: {
        total: 0,
        current: 1,
        pageSize: Constants.pageSize,
        size: "small",
      },
      selected: {},
      subCats: [],
      tags: [],
      exelFile: null,
      uploadLoading: false,
      printView: false,
      visibleScanModal: false,
      visibleDeleteBarcodeModal: false,
    };

    this.formRef = React.createRef();
    this.uploadRef = React.createRef();
    this.scanModalRef = React.createRef();
    this.deleteBarcode = React.createRef();

    this.handleFilter = debounce(this.handleFilter, 1000);
  }

  fetch = (params = {}) => {
    const {
      filterEndDate,
      filterStartDate,
      q
    } = this.state;
    // params.q = "";
    params.q = q ? q : ""
    
    params.endDate = filterEndDate
        ? moment(
            `${filterEndDate.year}-${filterEndDate.month}-${filterEndDate.day}`,
            Constants.jDateFormat
        ).format(Constants.dateFormat)
        : null;
    params.startDate = filterStartDate
        ? moment(
            `${filterStartDate.year}-${filterStartDate.month}-${filterStartDate.day}`,
            Constants.jDateFormat
        ).format(Constants.dateFormat)
        : null;

    this.setState({ loading: true });

    API.printBarcode
      .list(params)
      .then((result) => {
        if (result.data) {
          this.setState({
            loading: false,
            data: result.data,
            pagination: {
              ...this.state.pagination,
              ...{
                current: result.current_page,
                pageSize: result.per_page,
                total: result.total,
              },
            },
          });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  showModal = (product = {}) => {
    console.log(product);
    this.setState({ visibleModal: true, selected: product });

    setTimeout(() => {
      this.formRef.current.handleDidMount(product);
    }, 0);
  };
  showScanBarcodeModal = async (product = {}) => {
   
    this.setState({ visibleScanModal: true, selected: product });

    setTimeout(() => {
      this.scanModalRef.current.handleDidMount(product);
    }, 0);
  };

  hideScanBarcodeModal = () => {
    this.setState({ visibleScanModal: false });

    setTimeout(() => {
      this.scanModalRef.current.handleWillUnmount();
    }, 0);
  };

  showDeleteBarcodeModal = async (product = {}) => {
    product.range = await this.getPrintBarcodesDetail(product.id)
    this.setState({ visibleDeleteBarcodeModal: true, selected: product });

    setTimeout(() => {
      this.deleteBarcode.current.handleDidMount(product);
    }, 0);
  };

  hideDeleteBarcodeModal = () => {
    this.setState({ visibleDeleteBarcodeModal: false });

    setTimeout(() => {
      this.deleteBarcode.current.handleWillUnmount();
      this.fetch({page: this.state.pagination.current, q:this.state.filterSearch})
    }, 0);
  };
  hideModal = () => {
    this.setState({ visibleModal: false });

    setTimeout(() => {
      this.formRef.current.handleWillUnmount();
    }, 0);
  };

  showDrawer = (product = {}) => {
    this.setState({ visibleDrawer: true, selected: product });
  };

  hideDrawer = () => {
    this.setState({ visibleDrawer: false });
  };

  showUpload = (product = {}) => {
    this.setState({ visibleUpload: true, selected: product });

    setTimeout(() => {
      this.uploadRef.current.handleDidMount(product.id);
    }, 0);
  };

  hideUpload = () => {
    this.setState({ visibleUpload: false });

    setTimeout(() => {
      this.uploadRef.current.handleWillUnmount();
    }, 0);
  };

  handleFilter = (value, obj) => {
    const state = {};
    state[obj] = value;

    this.setState(state);

    setTimeout(() => {
      this.fetch({ page: 1});
    }, 0);
  };

  handleUpload = (values) => {
    this.setState({ submitting: true });

    API.product
      .addImage(values)
      .then((result) => {
        message.success(result.message);
        this.setState({ submitting: false });
        this.hideUpload();
        this.fetch({ page: this.state.pagination.current,  q:this.state.filterSearch});
      })
      .catch(() => {
        this.setState({ submitting: false });
      });
  };



  handleDelete = (record) => {
    Modal.confirm({
      title: Resources.confirmDeleteImage,
      okText: Resources.yes,
      okType: "danger",
      cancelText: Resources.no,
      onOk: () => {
        this.setState({ loading: true });

        API.printBarcode
          .delete(record)
          .then((result) => {
            message.success(result.message);

            this.fetch({ page: this.state.pagination.current, q:this.state.filterSearch });
          })
          .catch(() => {
            this.setState({ loading: false });
          });
      },
    });
  };

  handleSubmit = (values) => {
    const action = this.state.selected.id ? API.printBarcode.update : API.printBarcode.add;

    this.setState({ submitting: true });

    action(values, this.state.selected.id)
        .then((result) => {
          message.success(result.message);
          this.setState({ submitting: false });
          this.hideModal();
          this.fetch({ page: this.state.pagination.current, q:this.state.filterSearch });
        })
        .catch(() => {
          this.setState({ submitting: false });
        });
  }

  handleTableChange = (pagination) => {
    this.fetch({ page: pagination.current,  q:this.state.filterSearch});
  };

  componentDidMount() {
    const { onSetRoute, routeName, parentName } = this.props;
    const { catId, subCatId } = this.props.match.params;

    onSetRoute({ openKey: parentName, selectedKey: routeName });


    setTimeout(() => {
      this.fetch({ page: 1 , q:this.state.filterSearch});
    }, 0);
  }

  showPrint = async (product = {}) => {
    product.range = await this.getPrintBarcodesDetail(product.id)
    this.setState({ printView: true, selected: product });
  };
  hideView = () => {
    this.setState({  printView: false });
  };

  getPrintBarcodesDetail = (printBarcodeId) => {
    return API.printBarcode.getPrintBarcodesDetail(printBarcodeId)
      .then((result) => {
        return result.data
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  render() {
    const {
      data,
      loading,
      mainCats,
      pagination,
      submitting,
      visibleModal,
      printView,
      selected,
      visibleScanModal,
      visibleDeleteBarcodeModal,
      filterEndDate,
      filterStartDate,

    } = this.state;
    const { permissions } = this.props;
    const { catId, subCatId } = this.props.match.params;

    const columns = [
      {
        title: Resources.title,
        dataIndex: "name",
        className: "col-center",
        width: "130px",
      },
,
      {
        title: Resources.barcode,
        dataIndex: "code",
        className: "col-center",
        width: "130px",
      },
      {
        title: Resources.count,
        dataIndex: "count",
        className: "col-center",
        width: "90px",
      },
      {
        title: Resources.counter,
        dataIndex: "counter",
        className: "col-center",
        width: "90px",
      },
      {
        title: Resources.packing,
        dataIndex: "package_count",
        className: "col-center",
        width: "90px",
      },
      {
        title: Resources.row,
        dataIndex: "row",
        className: "col-center",
        width: "90px",
      },
      {
        title: Resources.identifier,
        dataIndex: "identifier",
        className: "col-center",
        width: "90px",
      },
      {
        title: Resources.shelf,
        dataIndex: "shelf",
        className: "col-center",
        width: "90px",
      },
      {
        title: Resources.size,
        dataIndex: "size",
        className: "col-center",
        width: "90px",
      },
      {
        title: Resources.dateAndTime,
        dataIndex: "created_at",
        width: "30px",
        render: (val) => moment(val).format(Constants.jDateTimeFormat),
      },
      {
        title: Resources.action,
        dataIndex: "id",
        className: "col-center",
        width: "120px",
        render: (val, record) => (
            <Fragment>
              <Tooltip title={Resources.edit}>
                <Button
                    type="link"
                    icon={<EditOutlined />}
                    onClick={() => this.showModal(record)}
                />
              </Tooltip>
              <Tooltip title={Resources.delete}>
                <Button
                    type="link"
                    icon={<DeleteOutlined />}
                    onClick={() => this.handleDelete(val)}
                />
              </Tooltip>

              <Tooltip title={Resources.print}>
                <Button
                    type="link"
                    icon={<PrinterOutlined />}
                    onClick={() => this.showPrint(record)}
                />
              </Tooltip>

              <Tooltip title={Resources.deleteSpecificBarcode}>
                <Button
                    type="link"
                    icon={<ClearOutlined />}
                    onClick={() => this.showDeleteBarcodeModal(record)}
                />
              </Tooltip>
            </Fragment>
        ),
      },


    ];

    const DatePickerInput = ({ ref }, date, placeholder) => (
        <Input
            value={date ? `${date.year}-${date.month}-${date.day}` : date}
            placeholder={placeholder}
            ref={ref}
            readOnly
        />
    );

    return (
      <Fragment>
        <PrintView
            data={selected}
            visible={printView}
            onClose={this.hideView}
        />
        <Breadcrumb>
          <Breadcrumb.Item>{Resources.printBarcode}</Breadcrumb.Item>
        </Breadcrumb>
        <div className="ant-content">
          <Row gutter={24}>
            <Col xs={24} md={4}>
              <Tooltip title={Resources.searchHintOffer}>
                <Input
                  type="text"
                  prefix={<SearchOutlined />}
                  placeholder={Resources.search}
                  onChange={({ target: { value } }) =>
                    this.handleFilter(value, "q")
                  }
                  allowClear
                />
              </Tooltip>
            </Col>
            <Col xs={24} md={6}>
              <DatePicker
                  locale="fa"
                  value={filterStartDate}
                  onChange={(value) =>
                      this.handleFilter(value, "filterStartDate")
                  }
                  renderInput={(ref) =>
                      DatePickerInput(ref, filterStartDate, Resources.fromDate)
                  }
                  shouldHighlightWeekends
              />
              {filterStartDate && (
                  <CloseCircleFilled
                      style={{zIndex: "1000000000"}}

                      className="ant-input-clear-icon ant-input-clear-icon-external"
                      onClick={() => this.handleFilter(null, "filterStartDate")}
                  />
              )}
            </Col>
            <Col xs={24} md={6}>
              <DatePicker
                  locale="fa"
                  value={filterEndDate}
                  onChange={(value) => this.handleFilter(value, "filterEndDate")}
                  renderInput={(ref) =>
                      DatePickerInput(ref, filterEndDate, Resources.toDate)
                  }
                  shouldHighlightWeekends
              />
              {filterEndDate && (
                  <CloseCircleFilled
                      style={{zIndex: "1000000000"}}
                      className="ant-input-clear-icon ant-input-clear-icon-external"
                      onClick={() => this.handleFilter(null, "filterEndDate")}
                  />
              )}
            </Col>

            <Col xs={24} md={4}>
              <Button type="primary" icon={<PlusOutlined />} onClick={() => this.showModal()} block>{Resources.add}</Button>
            </Col>
          </Row>
        </div>
        <div className="ant-content">
          <Row gutter={24}>

          </Row>
          <Table
            columns={columns}
            dataSource={data}
            loading={loading}
            onChange={this.handleTableChange}
            pagination={pagination}
            size="small"
            rowKey="id"
            scroll={{ x: 936 }}
          />
          {!!pagination.total && (
            <PaginationInfo
              current={pagination.current}
              pageSize={pagination.pageSize}
              total={pagination.total}
            />
          )}
        </div>

        <PrintBarcodeForm
          ref={this.formRef}
          onCancel={this.hideModal}
          onSubmit={this.handleSubmit}
          submitting={submitting}
          visible={visibleModal}
        />
        <DeleteBarcode
            ref={this.deleteBarcode}
            onCancel={this.hideDeleteBarcodeModal}
            // onSubmit={this.handleSubmit}
            submitting={submitting}
            visible={visibleDeleteBarcodeModal}
        />
      </Fragment>
    );
  }
}

export default connect(
  (state) => {
    return {
      permissions: {
        action: CheckPermission(state.app.user, Permissions.print_barcode),
      },
    };
  },
  (dispatch) => {
    return {
      onSetRoute: (data) => dispatch(SetRoute(data)),
    };
  }
)(PrintBarcode);
